'use client'

import { useRootLayout } from '@/app/[locale]/(layout)/_layout/useRootLayout'
import { usePathname, useRouter } from "@/locales/routing"
import { ScrollElementProvider } from '@/provider/ScrollElementProvider'
import { ChevronsLeft } from "@/ui/icons/ChevronsLeft"
import { Button, cn, Divider, ScrollShadow, Tab, Tabs } from "@heroui/react"
import { Variants } from "framer-motion"
import { useTranslations } from 'next-intl'
import { useRef } from 'react'
import { GroupList } from "./GroupList"
import { UserList } from "./UserList"



const TabTitle = ({ title }: { title: string }) => {
  return (
    <div className="text-theme-primary/40 text-sm group-data-[selected=true]:text-theme-primary group-data-[selected=true]:font-bold">{title}</div>
  )
}
export const asideVariants: Variants = {
  default: {
    x: 0,
    transition: {
      ease: 'easeOut',
      duration: .2

    }
  },
  collapse: {
    x: -356,
  },
  hidden: {
    x: -356,
    transition: {
      ease: 'easeOut',
      duration: .2
    }
  }
}

export const UserAside = ({ defaultTabKey }: { defaultTabKey?: string }) => {
  const router = useRouter()
  const pathname = usePathname()
  const t = useTranslations()

  const [setAsideWrapper] = useRootLayout(state => [state.setAsideWrapper])

  const onPressChevron = () => {
    setAsideWrapper('hidden')
  }
  // 退出登录
  const userContainer = useRef(null!)
  const groupContainer = useRef(null!)


  return (
    <>
      <div
        className={cn(
          "flex max-w-[300px] flex-1 lg:w-[300px] flex-shrink-0 w-full border-r-1 border-r-theme-primary/10 bg-surface  h-full",
        )}
      >

        {/* user list */}
        <div className="px-2 pt-5 flex flex-col flex-1">

          <div className="flex justify-end flex-shrink-0">
            <Button
              radius="full"
              className="bg-theme-primary/5"
              onPress={onPressChevron}
              isIconOnly><ChevronsLeft /></Button>
          </div>

          <div className="pt-[20px] overflow-hidden lg:pt-0 flex-1 flex flex-col">
            <Tabs
              variant="light"
              defaultSelectedKey={defaultTabKey}
              onSelectionChange={(v) => { router.push(`/${pathname}?type=${v}`,) }}
              classNames={{
                base: "w-[100%] px-[14px]",
                tabList: "flex-1 ",
                tabContent: "font-bold",
                panel: "flex-1 flex flex-col overflow-hidden",
                cursor: 'bg-seleced-bg shadow-none rounded-full'
              }}>
              <Tab key="individual" title={<TabTitle title={t('chat.userTab.chat')} />} >
                <Divider className="bg-theme-primary/5 mt-[8px]" />
                <ScrollShadow className='flex-1' hideScrollBar ref={userContainer}>
                  <ScrollElementProvider value={{ container: userContainer }}>

                    <UserList />
                  </ScrollElementProvider>

                </ScrollShadow>
              </Tab>
              <Tab key="group" title={<TabTitle title={t('chat.userTab.group')} />} >
                <Divider className="bg-theme-primary/5 mt-[8px]" />
                <ScrollShadow className='flex-1' hideScrollBar ref={groupContainer}>
                  <ScrollElementProvider value={{ container: groupContainer }}>
                    <GroupList />
                  </ScrollElementProvider>
                </ScrollShadow>

              </Tab>
            </Tabs>
          </div>

        </div>
      </div>
    </>

  )
}